class IntegrationService extends BaseService
	@register angular.module 'App.Service'
	@inject '$window',
		'$state'
		'IntegrationRepository'
		'CredentialsManager'
		'localStorageService'
		'Guid'
		'ConfigurationService'
		'EACCOUNTING_AUTH_URI'
		'EACCOUNTING_CLIENT_ID'

	isConnected: (integrationId) ->
		if !integrationId?
			throw new Error('No integration id provided')

		@IntegrationRepository
			.getEntities()
			.then (integrations) =>
				for integration of integrations
					if integration.id == integrationId && integration.is_connected
						return true

				return false


	##
	# `redirect_url` must be whitelisted with eAccounting support
	# Current whitelisted `redirect_url`:
	#
	# 1. Production account:
	# wallmob:
	# http://localhost:44300/callback
	# https://wbo-etail.wallmob.com/settings/integrations/eaccounting/auth
	# https://wbo-etail.wallmob.com/auth?redirect_url=/settings/integrations/eaccounting/auth
	# https://wbo-nexgenprod.wallmob.com/auth?redirect_url=/settings/integrations/eaccounting/auth
	# https://wbo-superbprod.wallmob.com/auth?redirect_url=/settings/integrations/eaccounting/auth
	#
	# vismaretailas
	# no account for production
	#
	# 2. Sandbox account:
	# wallmob
	# http://localhost:44300/callback
	#
	# vismaretailas
	#
	# http://localhost:44300/callback
	# https://wbo-dv.wallmob.com/settings/integrations/eaccounting/auth
	# https://wbo-dv.wallmob.com/auth?redirect_url=/settings/integrations/eaccounting/auth
	# https://wbo-tst.wallmob.co/auth?redirect_url=/settings/integrations/eaccounting/auth
	# https://wbo-tst.wallmob.com/settings/integrations/eaccounting/auth
	# https://wbo-etail.wallmob.com/auth?redirect_url=/settings/integrations/eaccounting/auth
	# https://wbo-etail.wallmob.com/settings/integrations/eaccounting/auth
	# https://wbo-nexgentest.wallmob.com/auth?redirect_url=/settings/integrations/eaccounting/auth
	# https://wbo-nexgenprod.wallmob.com/auth?redirect_url=/settings/integrations/eaccounting/auth
	# https://wbo-superbtest.wallmob.com/auth?redirect_url=/settings/integrations/eaccounting/auth
	# https://wbo-superbprod.wallmob.com/auth?redirect_url=/settings/integrations/eaccounting/auth
	# http://localhost:8030/settings/integrations/eaccounting/auth
	# http://localhost:8030/auth?redirect_url=/settings/integrations/eaccounting/auth
	##
	getEaccountingRequestUrl: ->
		state = @Guid.randomString()
		@localStorageService.set('auth.eaccounting.state', state)

		# `prompt` and `acr_values` are recommended and are directly from documentation
		return @EACCOUNTING_AUTH_URI +
			'?client_id=' + @EACCOUNTING_CLIENT_ID +
			'&redirect_uri=' + encodeURIComponent(@getEaccountingRedirectUrl()) +
			'&scope=' + encodeURIComponent('offline_access ea:api ea:sales ea:accounting ea:purchase') +
			'&response_type=code' +
			'&state=' + encodeURIComponent(state) +
			'&prompt=select_account' +
			'&acr_values=' + encodeURIComponent('service:44643EB1-3F76-4C1C-A672-402AE8085934')

	getEaccountingRedirectUrl: ->
		redirectUrl = @$state.href('integrations.static_callback', {id: 'eaccounting'}, {absolute: true, inherit: false})

		if redirectUrl?
			return redirectUrl

		throw new Error('State static_callback not found')


	getPaymentAccounts: (forEaccounting = true) ->
		return [
			{
				title: if forEaccounting then 'wbo.integration.eaccounting.bank.payments' else 'credit.card.payments'
				key: if forEaccounting then 'bank_payments' else 'card_payments'
				visible: true
			}
			{
				title: 'wbo.integration.eaccounting.cash.payments'
				key: 'cash_payments'
				visible: true
			}
			{
				title: 'wbo.integration.eaccounting.misc.payments'
				key: if forEaccounting then 'misc_payments' else 'miscellaneous_payments'
				visible: true
			}
			{
				title: 'wbo.integration.eaccounting.vippspayments.payments'
				key: 'vipps_payments'
				visible: @ConfigurationService.isEnabled('Shared.Setting.Integrations.VippsMobilePay.Enabled') ||
					@ConfigurationService.isEnabled('Shared.Setting.Integrations.Vipps.Enabled')
			}
			{
				title: 'wbo.integration.eaccounting.voucher.payments'
				key: 'voucher_payments'
				visible: @ConfigurationService.isEnabled 'Backoffice.TopMenu.Vouchers'
			}
			{
				title: 'wbo.integration.eaccounting.giftcard.payments'
				key: 'giftcard_payments'
				visible: @ConfigurationService.isEnabled 'POS.Setting.GiftCardFeatures.Enabled'
			}
			{
				title: 'wbo.integration.eaccounting.invoice.payments'
				key: 'invoice_payments'
				visible: @ConfigurationService.isEnabled 'Shared.Payment.InvoiceType.Enabled'
			}
			{
				title: 'general.dintero'
				key: 'dintero_payments'
				visible: @ConfigurationService.isEnabled 'Shared.Payment.Dintero.Enabled'
			}
			{
				title: 'general.application.payments'
				key: 'application_payments'
				visible: true
			}
			{
				title: 'general.loyalty.points.payments'
				key: 'loyalty_points_payments'
				visible: true
			}
			{
				title: 'general.omnikassa'
				key: 'omnikassa_payments'
				visible: true
			}
			{
				title: 'wbo.integration.svea'
				key: 'svea_payments'
				visible: @ConfigurationService.isEnabled 'Shared.Setting.Integrations.Svea.Enabled'
			}
			{
				title: 'general.adyen'
				key: 'adyen_payments'
				visible: true
			}
			{
				title: 'wbo.integration.swish.header'
				key: 'swish_payments'
				visible: @ConfigurationService.isEnabled 'Shared.Setting.Integrations.Swish.Enabled'
			}
			{
				title: 'general.mobile_pay'
				key: 'mobile_pay_payments'
				visible: @ConfigurationService.isEnabled 'Shared.Setting.Integrations.VippsMobilePay.Enabled'
			}
			{
				title: 'wbo.integration.resursbank.header'
				key: 'resursbank_payments'
				visible: @ConfigurationService.isEnabled 'Shared.Setting.Integrations.Resursbank.Enabled'
			}
		]

	getMappableSftpAccounts: ->
		accountsToExclude = ['card_payments', 'miscellaneous_payments']

		return _.filter @getPaymentAccounts(false), (account) ->
			!accountsToExclude.includes(account.key)
